import * as React from "react";
import { styled } from "@mui/material/styles";
import {
  Table, TableBody, TableContainer, TableHead, TableRow, Paper, Container, IconButton,
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, Chip
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { Download } from "@mui/icons-material";

import { useState, useEffect } from "react";

import Config from "../config.json";
import { dateToStringDate } from "../Helpers";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function Qcqa() {
  const url_list = Config.api_domain + "/qcqa/active/";
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(true); // Auto-open on page load

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(url_list, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        if (!res.ok) throw new Error("Server error");
        const data = await res.json();
        setList(data.data || []);
      } catch (error) {
        console.error("Fetch error:", error.message);
      }
    };
    fetchData();
  }, [url_list]);

  const procurementTimeline = [
  { no: 1,  activity: "Announcement",                                    start: "23 December 2025 13.00 (GMT+7)",  end: "8 January 2026 12.00 (GMT+7)"   },
  { no: 2,  activity: "Submission of Expressions of Interests (EOI)",    start: "23 December 2025 13.00 (GMT+7)",  end: "8 January 2026 12.00 (GMT+7)"   },
  { no: 3,  activity: "Shortlist Appointment",                           start: "8 January 2026 12.01 (GMT+7)",   end: "6 March 2026 23.59 (GMT+7)"     },
  { no: 4,  activity: "Shortlist Announcement and Issuance of RFP",      start: "9 March 2026 00.00 (GMT+7)",     end: "27 April 2026 12.00 (GMT+7)"    },
  { no: 5,  activity: "Clarification Request Period",                    start: "11 March 2026 09.00 (GMT+7)",    end: "17 April 2026 09.00 (GMT+7)"    },
  { no: 6,  activity: "Submission of Technical and Financial Proposals", start: "9 March 2026 00.00 (GMT+7)",     end: "27 April 2026 12.00 (GMT+7)"    },
  { no: 7,  activity: "Opening of Technical Proposal",                   start: "27 April 2026 13.00 (GMT+7)",    end: "27 April 2026 14.00 (GMT+7)"    },

  { no: 8,  activity: "Evaluation of Technical Proposals",              start: "27 April 2026 14.01 (GMT+7)",    end: "10 June 2026 23.59 (GMT+7)"     },
  { no: 9,  activity: "Technical Rank Announcement",                    start: "11 June 2026 00.00 (GMT+7)",     end: "11 June 2026 23.59 (GMT+7)"     },
  { no: 10, activity: "Opening of Financial Proposals",                 start: "29 June 2026 10.00 (GMT+7)",     end: "29 June 2026 12.00 (GMT+7)"     },
  { no: 11, activity: "Evaluation of Financial Proposals",              start: "30 June 2026 10.01 (GMT+7)",     end: "6 July 2026 23.59 (GMT+7)"      },
  { no: 12, activity: "Combined Evaluation",                            start: "5 July 2026 00.00 (GMT+7)",      end: "6 July 2026 23.59 (GMT+7)"      },
  { no: 13, activity: "Final Ranking",                                  start: "6 July 2026 00.00 (GMT+7)",      end: "6 July 2026 23.59 (GMT+7)"      },
  { no: 14, activity: "Contract Negotiation",                           start: "7 July 2026 00.00 (GMT+7)",      end: "9 July 2026 23.59 (GMT+7)"      },
  { no: 15, activity: "Notification of Intention to Award",            start: "21 July 2026 00.00 (GMT+7)",     end: "21 July 2026 23.59 (GMT+7)"     },
  { no: 16, activity: "Standstill / Debriefing Period",                 start: "22 July 2026 00.00 (GMT+7)",     end: "4 August 2026 16.00 (GMT+7)"    },
  { no: 17, activity: "Notification of Award",                          start: "5 August 2026 00.00 (GMT+7)",    end: "5 August 2026 23.59 (GMT+7)"    },
  { no: 18, activity: "Contract Signing",                               start: "6 August 2026 00.00 (GMT+7)",    end: "14 August 2026 23.59 (GMT+7)"   },
];

  function getRows() {
    if (typeof list !== "undefined" && list !== null && list.length > 0) {
      return list.map((row, index) => {
        let dateISO = new Date(row.time_uploaded);
        let formatted_datetime = dateToStringDate(dateISO);
        return (
          <StyledTableRow key={row.public_id}>
            <StyledTableCell>{index + 1}</StyledTableCell>
            <StyledTableCell>{row.title}</StyledTableCell>
            <StyledTableCell>{formatted_datetime}</StyledTableCell>
            <StyledTableCell>
              <IconButton
                aria-label="download"
                component="a"
                href={Config.api_domain + "/qcqa/download/" + row.public_id}
                download
              >
                <Download />
              </IconButton>
            </StyledTableCell>
          </StyledTableRow>
        );
      });
    } else {
      return (
        <StyledTableRow key="no-data">
          <StyledTableCell colSpan={4} align="center">
            No Data Found
          </StyledTableCell>
        </StyledTableRow>
      );
    }
  }

  return (
    <div style={{ padding: "1em 2em 3em 2em" }}>
      <Container>

        {/* === AUTO-OPEN POPUP: Opening of Tech Proposal – QC/QA === */}
        <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
          <DialogTitle sx={{ backgroundColor: "#fff8f0", borderBottom: "2px solid #f57c00", pb: 1.5 }}>
            <Box display="flex" alignItems="center" gap={1}>
              <Chip
                label="QC/QA"
                size="small"
                sx={{
                  backgroundColor: "rgba(245, 124, 0, 0.1)",
                  color: "#f57c00",
                  fontWeight: 700,
                  border: "1px solid #f57c00",
                  fontSize: "0.75rem",
                }}
              />
              <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#2e2e2e" }}>
                Opening of Tech Proposal – Zoom Meeting
              </Typography>
            </Box>
          </DialogTitle>

          <DialogContent dividers sx={{ pt: 2 }}>
            <Typography paragraph sx={{ fontSize: "0.9rem", color: "#333" }}>
              ILASP PHLN invites you to join a scheduled Zoom meeting.
            </Typography>

            {/* Info rows */}
            {[
              {
                label: "Topic",
                value: "Opening of Tech Proposal: Quality Assurance and Quality Control Consultancy for the Provision of Base Maps of Indonesia",
              },
              { label: "Time", value: "27 April 2026, 01:00 PM Jakarta (GMT+7)" },
              { label: "Meeting ID", value: "946 3080 5104" },
              { label: "Passcode", value: "=y5^uuyj" },
              { label: "Join via SIP", value: "94630805104@zoomcrc.com" },
            ].map(({ label, value }) => (
              <Box key={label} display="flex" gap={1} mb={0.75} alignItems="flex-start">
                <Typography
                  sx={{
                    fontSize: "0.85rem",
                    fontWeight: 700,
                    color: "#f57c00",
                    minWidth: "110px",
                    flexShrink: 0,
                  }}
                >
                  {label}:
                </Typography>
                <Typography sx={{ fontSize: "0.85rem", color: "#333" }}>{value}</Typography>
              </Box>
            ))}

            {/* Zoom link */}
            <Box display="flex" gap={1} mb={0.75} alignItems="flex-start">
              <Typography
                sx={{ fontSize: "0.85rem", fontWeight: 700, color: "#f57c00", minWidth: "110px", flexShrink: 0 }}
              >
                Join Meeting:
              </Typography>
              <a
                href="https://big-go-id.zoom.us/j/94630805104?pwd=RDKRosA7YwAmacQbBf4XOR6eMbxvKl.1"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#f57c00", fontSize: "0.85rem", wordBreak: "break-all" }}
              >
                https://big-go-id.zoom.us/j/94630805104?pwd=RDKRosA7YwAmacQbBf4XOR6eMbxvKl.1
              </a>
            </Box>

            {/* Instructions link */}
            <Box display="flex" gap={1} mb={0.75} alignItems="flex-start">
              <Typography
                sx={{ fontSize: "0.85rem", fontWeight: 700, color: "#f57c00", minWidth: "110px", flexShrink: 0 }}
              >
                Instructions:
              </Typography>
              <a
                href="https://big-go-id.zoom.us/meetings/94630805104/invitations?signature=_4ODCapXfLvM9nN5MoSByY5WHOZjOGuPlg6sxlYLrjs"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#f57c00", fontSize: "0.85rem", wordBreak: "break-all" }}
              >
                https://big-go-id.zoom.us/meetings/94630805104/invitations
              </a>
            </Box>
          </DialogContent>

          <DialogActions sx={{ px: 3, py: 1.5 }}>
            <Button
              onClick={() => setOpen(false)}
              variant="contained"
              sx={{
                backgroundColor: "#f57c00",
                "&:hover": { backgroundColor: "#e65100" },
                textTransform: "none",
                fontWeight: 600,
                px: 3,
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* === PAGE CONTENT === */}
        <h2>QC/QA Base Maps</h2>

        <h3>Project Description</h3>
        <p style={{ textAlign: "justify" }}>
          As part of the implementation of the Integrated Land Administration and Spatial Planning (ILASP) Project, the Geospatial Information Agency (BIG) is seeking a consulting firm (or consortium) to provide quality assurance and quality control (QA/QC) services. The objective is to ensure the accuracy, consistency, and timely delivery of geospatial data and Base Maps. This assignment, scheduled for the period 2026–2029, will involve verifying the outputs of 3D geospatial data production in both urban and non-urban areas, as well as the Base Maps Production and Generalization of digital maps across various scales (from 1:5,000 up to 1:1,000,000). The selected consultant will act on behalf of BIG, work in close coordination with the Directorate of Land Topographic Mapping, and submit reports and documentation that will serve as the basis for project-related payment processes.
        </p>

        <h3>Announcement</h3>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 500 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>No</StyledTableCell>
                <StyledTableCell>Announcement</StyledTableCell>
                <StyledTableCell>Publication Date</StyledTableCell>
                <StyledTableCell>Download</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {getRows()}
            </TableBody>
          </Table>
        </TableContainer>

        <h3>Procurement Timeline</h3>
        <TableContainer component={Paper} sx={{ mb: 6 }}>
          <Table sx={{ minWidth: 700 }} aria-label="timeline table">
            <TableHead>
              <TableRow>
                <StyledTableCell>No.</StyledTableCell>
                <StyledTableCell>Activity</StyledTableCell>
                <StyledTableCell>Start Date</StyledTableCell>
                <StyledTableCell>End Date</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {procurementTimeline.map((row) => (
                <StyledTableRow key={row.no}>
                  <StyledTableCell>{row.no}</StyledTableCell>
                  <StyledTableCell>{row.activity}</StyledTableCell>
                  <StyledTableCell>{row.start}</StyledTableCell>
                  <StyledTableCell>{row.end}</StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Typography variant="caption" sx={{ display: "block" }}>
          All schedules are based on Jakarta time (GMT +7)
        </Typography>

        <p style={{ textAlign: "justify" }}>
          The package will be processed through SPSE ICB at the link:{" "}
          <a
            href="https://spseicb.lkpp.go.id/spseicb/lelang/view/2622999"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://spseicb.lkpp.go.id/spseicb/lelang/view/2622999
          </a>
        </p>

      </Container>
    </div>
  );
}

export default Qcqa;